/** User-facing label for the /bills product area (nav, section headers, empty states). */
export const POLICY_NAV_LABEL = "Policy";
